// C10 limits. The same numbers are enforced on the server (functions/src/session.ts) and in firestore.rules.
import type { Role } from '../types';

/** The screen locks after this long without use. Drafts stay on screen; the password unlocks it. */
export const IDLE_LOCK_MINUTES = 15;
/** Warnings appear this long before a lock or the end of a sign-in. */
export const WARN_SECONDS = 60;
/** How long one sign-in lasts: doctors and reception 12 hours; clinic admins and the super admin 8 hours. */
export const MAX_SESSION_HOURS: Record<Role, number> = { staff: 12, doctor: 12, facility_admin: 8, super_admin: 8 };
export const maxSessionMs = (role: Role) => (MAX_SESSION_HOURS[role] ?? 8) * 3600_000;
